import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

/* eslint-disable @typescript-eslint/naming-convention */
@Pipe({
    name: 'localizeFromParams',
    pure: true,
    standalone: false
})
export class LocalizationFromParamsPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) {}

    /**
     * Performs a transform operation on a localization key to get the string for the language that was passed in the params
     *
     * @param key key on which we want to check the localization on
     * @param locale is the language setting we are passing
     *
     * @returns Translated string
     */
    transform(key: string, locale: string): string  {
        return this.localizationService.transformWithLocale(key, locale || 'en');
    }
}
